import * as VariantActions from './actions'
import {store} from "../../reducers"
import {api} from "../index";
import {app} from "../../config/constants";


export const addVariationToDeletionQueue = ( variantKey ) => {
	store.dispatch(VariantActions.addVariationToDeletionQueue( variantKey ) );
};

export const deletePeriodVariant = async (variant) => {
	return new Promise( ( resolve, reject ) => {
		api.statistics.deleteStatistics(variant.key).then( () => {
			app.database().ref('/cams/promotions/variants/' + variant.key ).set(null).then( () => {
				resolve();
			});
		});
	});
};


// WEBPACK FOOTER //
// ./src/api/variants/index.js